import styled from 'styled-components'

export const DetailsMenuButtonContainer = styled.button`
  display: block;
  border-radius: 10px;
  padding: 1rem 0 1rem 1.5rem;
  color: var(--navyblue);
  background: none;
  text-align: left;
  text-transform: uppercase;
  width: 100%;
  transition all 400ms;

  &.selected {
    color: ${props => props.color};
    background: ${props => props.bgColor};
    pointer-events: none;
  }

  &:not(:last-child) {
    margin-bottom: 1.5rem;
  }

  span {
    font-weight: 500;
    font-size: 16px;
    line-height: 30px;
  }
`
